import { formDataComsToTiled } from '../DynamicComponent/config';
import { V2Confirm } from '@/common/components/Others/V2Confirm';

export const MODEL_SYNC_EVENT = 'standardChancePoint:updateModule';
export const CHANCE_MODEL_SYNC_WARNING = '模型数据尚未完成同步，建议退出详情并稍后重试，是否任然跳过同步继续执行？';
export const TASK_MODEL_SYNC_WARNING = '模型数据尚未完成同步，建议稍后重试，是否任然跳过同步继续执行？';

export interface ModelSyncOptions {
  latestDetail?: any;
  /** 审批前预同步不刷新详情或清空表单，后续仍需原审批的完整校验。 */
  shouldRefreshAfterSave?: boolean;
  /** 审批前置同步不显示“模型同步成功”提示。 */
  showModelSyncSuccess?: boolean;
}

export const getModelSyncFields = (detail: any): any[] => {
  const module = Array.isArray(detail?.moduleDetails) ? detail.moduleDetails.find(item => item.moduleType === 4) : undefined;
  const groups = module?.infoModule?.propertyGroupVOList;
  const fields: any[] = [];
  if (Array.isArray(groups)) formDataComsToTiled(JSON.parse(JSON.stringify(groups)), fields);
  return fields;
};

/** 数字控件的 textValue 可能是 { value, suffix }；0 也是有效数据。 */
export const hasModelSyncData = (detail: any): boolean => getModelSyncFields(detail).some(field => {
  if (field.identification !== 'ymKDJ') return false;
  let value = field.textValue;
  if (typeof value === 'string') {
    if (!value.trim()) return false;
    try {
      value = JSON.parse(value);
    } catch {
      // 非 JSON 的纯文本仍按原始字段值判断。
    }
  }
  if (value && typeof value === 'object') value = value.value;
  return value !== undefined && value !== null && (typeof value !== 'string' || value.trim() !== '');
});

/** 保留打开详情后用户改过的字段，用最新接口值补齐未修改的模型输入。 */
export const mergeModelSyncFields = (current: any[], initial: any[], latest: any[]) => {
  const changed: any[] = [];
  current.forEach(field => {
    const sameField = (item: any) => item.identification === field.identification && item.propertyId === field.propertyId;
    const original = initial.find(sameField);
    const updated = latest.find(sameField);
    if (original && updated && field.textValue === original.textValue && field.textValue !== updated.textValue) {
      field.textValue = updated.textValue;
      changed.push(field);
    }
  });
  return changed;
};

export const confirmSkipModelSync = (content: string) => new Promise<boolean>(resolve => {
  V2Confirm({
    content,
    okText: '是',
    cancelText: '否',
    onSure: () => resolve(true),
    onCancel: () => resolve(false),
  });
});

export const prepareModelSyncApproval = async ({
  enabled, id, message, getDetail, synchronize, confirmSkip = confirmSkipModelSync, isCurrent = () => true,
}: {
  enabled: boolean;
  id: number | string;
  message: string;
  getDetail: (params: { id: number | string }) => Promise<any>;
  synchronize: (detail: any) => Promise<boolean>;
  confirmSkip?: (content: string) => Promise<boolean>;
  isCurrent?: () => boolean;
}): Promise<boolean> => {
  if (!enabled) return true;
  try {
    const latestDetail = await getDetail({ id });
    if (!isCurrent()) return false;
    const result = hasModelSyncData(latestDetail) ? await synchronize(latestDetail) : await confirmSkip(message);
    return isCurrent() && result;
  } catch (error) {
    // 请求层负责接口错误提示；失败时不得退化成跳过同步继续审批。
    console.log('审批前模型同步未完成', error);
    return false;
  }
};
